import { FC, useState, useEffect, ReactNode } from 'react';

import { useInView } from 'react-intersection-observer';

import { useWindowSize } from '@hooks_common/useWindowSize';

type Props = {
  dependency: any;
  children: ReactNode;
};

const RenderOnScroll: FC<Props> = ({ dependency, children }) => {
  const [render, setRender] = useState(false);
  const { height: windowHeight } = useWindowSize();
  const { ref: inViewObserver, inView } = useInView({
    rootMargin: `0px 0px ${windowHeight * 0.5}px 0px`,
    threshold: 0,
  });

  //ファーストビューに表示されているときはすぐにレンダリングする為
  useEffect(() => {
    if (inView) {
      setRender(true);
    }
  }, [inView]);

  useEffect(() => {
    //同階層ページ遷移時にリセット
    if (dependency) {
      setRender(false);
    }
  }, [dependency]);

  return <>{render ? children : <div ref={inViewObserver}></div>}</>;
};

export default RenderOnScroll;
